import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IDropdown } from "../../models/BaseModel";
import { JVDropdownInput } from "../../shared/JVDropdownInput";

export interface IFilter {
    // contact?: IDropdown;
    // contactId?: number;
    // statusId?: number;
    // sourceId?: number;
    countryId?: number;
    stateId?: number;
    cityId?: number;
    assignedTo?: number;
    createdBy?: number;
    updatedBy?: number;
    fromDate?: Date | string | null;
    toDate?: Date | string | null;
    leadAssigned?: number; // <-- Ne
}

const schema = yup.object({});

interface Iprops {
    filter: IFilter,
    loading: boolean,
    header: any,
    toast: any,
    setFilter: (filter: IFilter) => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>();
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    // const [contacts, setContacts] = useState<IDropdown[]>();
    // const [sources, setSources] = useState<IDropdown[]>();
    // const [status, setStatus] = useState<IDropdown[]>();

    const { control, handleSubmit, reset, watch, setValue } = useForm<IFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filter,
        shouldFocusError: false
    });

    const countryId = watch("countryId");
    const stateId = watch("stateId");

    useEffect(() => {
        loadCountries();
        loadUsers();

    }, []);

    useEffect(() => {
        if (countryId) {
            setValue("stateId", undefined);
            setValue("cityId", undefined);
            setStates([]);
            setCities([]);
            loadStates(countryId);
        }
    }, [countryId]);

    useEffect(() => {
        if (stateId) {
            setValue("cityId", undefined);
            setCities([]);
            loadCities(stateId);
        }
    }, [stateId]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            const countryList = await response.json();
            setCountries([{ id: undefined, name: "--Select Country--" }, ...countryList]);
        }
    }


    const leadAssignedOptions: IDropdown[] = [
        { id: 3, name: "All" },
        { id: 1, name: "Already Assigned" },
        { id: 2, name: "Not Assigned" }

    ];

    const loadUsers = async () => {
        const response = await Fetch("Dropdown/getuser", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setUsers([{ id: undefined, name: "--Select--" }, ...userList]);
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            const stateList = await response.json();
            setStates([{ id: undefined, name: "--Select State--" }, ...stateList]);
        }
    }

    const loadCities = async (stateId: number) => {
        const response = await Fetch(`city/dropdown/${stateId}`, "GET", null, null, null);
        if (response) {
            const cityList = await response.json();
            setCities([{ id: undefined, name: "--Select City--" }, ...cityList]);
        }
    }

    const searchToDB = async (body: IFilter) => { props.setFilter(body); }

    function onSubmit(data: IFilter) {
        data.fromDate = data.fromDate === "" || data.fromDate == null ? null : data.fromDate;
        data.toDate = data.toDate === "" || data.toDate == null ? null : data.toDate;

        if (data.fromDate && data.toDate) {
            const fromDate = new Date(data.fromDate);
            const toDate = new Date(data.toDate);

            if (toDate < fromDate) {
                props.toast.current?.show({
                    severity: "warn",
                    summary: "Validation",
                    detail: "To Date cannot be less than From Date.",
                    life: 4000,
                });
                return;
            }
        }

        searchToDB(data);
    }

    const Clear = () => {
        reset({
            countryId: undefined,
            stateId: undefined,
            cityId: undefined,
            assignedTo: undefined,
            createdBy: undefined,
            updatedBy: undefined,
            fromDate: null,
            toDate: null,
            leadAssigned: 3
        });

        setStates([]);
        setCities([]);
    }

    return (
        <Accordion>
            <AccordionTab header={props.header}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDate
                        column={4}
                        label="From Date"
                        control={control}
                        name="fromDate"
                        maxDate={new Date()}
                        placeholder="Select From Date"
                    />

                    <JVDate
                        column={4}
                        label="To Date"
                        control={control}
                        name="toDate"
                        maxDate={new Date()}
                        placeholder="Select To Date"
                    />

                    <JVDropdown
                        column={4}
                        label="Country"
                        control={control}
                        options={countries}
                        optionLabel="name"
                        optionValue="id"
                        name="countryId"
                        placeholder="Select Country"
                    />

                    <JVDropdown
                        column={4}
                        label="State"
                        control={control}
                        options={states}
                        optionLabel="name"
                        optionValue="id"
                        name="stateId"
                        placeholder="Select State"
                    />

                    <JVDropdown
                        column={4}
                        label="City"
                        control={control}
                        options={cities}
                        optionLabel="name"
                        optionValue="id"
                        name="cityId"
                        placeholder="Select City"
                    />

                    <JVDropdown
                        column={4}
                        label="Created By"
                        control={control}
                        options={users}
                        optionLabel="name"
                        optionValue="id"
                        name="createdBy"
                        placeholder="Select User"
                    />

                    <JVDropdown
                        column={4}
                        label="Updated By"
                        control={control}
                        options={users}
                        optionLabel="name"
                        optionValue="id"
                        name="updatedBy"
                        placeholder="Select User"
                    />

                    <JVDropdown
                        column={4}
                        label="Lead Status"
                        control={control}
                        options={leadAssignedOptions}
                        optionLabel="name"
                        optionValue="id"
                        name="leadAssigned"
                        placeholder="Select Status"
                    />



                    <div className="col-12 md:col-4 gap-4 flex align-items-center justify-content-center mt-3">
                        <Button
                            style={{ width: '100px', height: '34px' }}
                            loading={props.loading}
                            label="SEARCH"
                            type="submit"
                            className="p-button-rounded"
                        />

                        <Button
                            style={{ width: '100px', height: '34px' }}
                            label="CLEAR"
                            onClick={Clear}
                            type="button"
                            className="p-button-rounded p-button-outlined surface-200"
                        />
                    </div>

                </form>
            </AccordionTab>
        </Accordion>
    );
}
